import { NavLink, useLocation } from 'react-router-dom';
import {
  HomeIcon as HomeOutline,
  DocumentTextIcon as DocumentOutline,
  CurrencyDollarIcon as DollarOutline,
  UserCircleIcon as UserOutline,
} from '@heroicons/react/outline';
import {
  HomeIcon as HomeSolid,
  DocumentTextIcon as DocumentSolid,
  CurrencyDollarIcon as DollarSolid,
  UserCircleIcon as UserSolid,
} from '@heroicons/react/solid';

import useAuthStore from '../../store/authStore';

const BottomNavBar = () => {
  const location = useLocation();
  const { userData } = useAuthStore();
  const isLawyer = userData?.role === 'lawyer';

  const navigation = [
    { name: 'الرئيسية', href: '/', outlineIcon: HomeOutline, solidIcon: HomeSolid },
    { name: 'العقود', href: '/contracts', outlineIcon: DocumentOutline, solidIcon: DocumentSolid },
    ...(isLawyer 
      ? [
          { name: 'المالية', href: '/finance', outlineIcon: DollarOutline, solidIcon: DollarSolid }
        ] 
      : [
          { name: 'الدفعات', href: '/payments', outlineIcon: DollarOutline, solidIcon: DollarSolid }
        ]
    ),
    { name: 'الملف الشخصي', href: '/profile', outlineIcon: UserOutline, solidIcon: UserSolid },
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 bg-white border-t border-gray-200 z-30" style={{
      maxWidth: '530px',
    }}>
      <div className="flex justify-around h-16">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = isActive ? item.solidIcon : item.outlineIcon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={`flex-1 flex flex-col items-center justify-center text-sm font-medium ${
                isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-600'
              }`}
            >
              <Icon className="h-6 w-6 mb-1" aria-hidden="true" />
              <span className="text-xs tracking-tight">{item.name}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavBar;
